<template>
	<view class="box">
		<scroll-view scroll-x class="box_head">
			<view class="box_head_list">
				<view class="box_head_item active">全部</view>
				<view class="box_head_item">待审核</view>
				<view class="box_head_item">审核通过</view>
				<view class="box_head_item">审核驳回</view>
			</view>
		</scroll-view>
		<view class="box_list">
			<view class="box_list_item" v-for="(item, index) in 3" :key="index">
				<view class="box_list_item_head">
					<text>丁恩凯的劳务入厂申请</text>
					<text class="loading">待审核</text>
				</view>
				<view class="box_list_item_nr">
					<view class="box_list_item_nr_item">
						<text>被访问人：</text>
						<text>人事部-王亚蓝</text>
					</view>
					<view class="box_list_item_nr_item">
						<text>进厂时间：</text>
						<text>12-12 09:00</text>
					</view>
					<view class="box_list_item_nr_item">
						<text>离厂时间：</text>
						<text>12-12 12:00</text>
					</view>
					<view class="box_list_item_nr_item">
						<text>入厂人数：</text>
						<text>10</text>
					</view>
					<view class="box_list_item_nr_item">
						<text>来访事由：</text>
						<text>业务来往</text>
					</view>
					<view class="box_list_item_nr_x"></view>
					<view class="box_list_item_nr_text">
						2023-12-12 09:00提交
					</view>
				</view>
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			};
		}
	}
</script>
<style>
	page {
		background-color: #F7F7F7 !important;
	}
</style>
<style lang="scss" scoped>
	.box {
		width: 100%;
		.box_head {
			width: 100%;
			height: 108rpx;
			padding: 0 30rpx;
			box-sizing: border-box;
			background: #FFFFFF;
			position: sticky;
			top: 0;
			left: 0;
			.box_head_list {
				width: 100%;
				height: 100%;
				display: flex;
				align-items: center;
				.active {
					border: 1rpx solid #279BAA !important;
					color: #279BAA !important;
				}
				.box_head_item {
					padding: 0 30rpx;
					height: 60rpx;
					line-height: 60rpx;
					box-sizing: border-box;
					border-radius: 30rpx;
					border: 1rpx solid #999999;
					font-size: 26rpx;
					font-weight: 400;
					color: #333333;
					margin-right: 20rpx;
				}
			}
		}
		.box_list {
			width: 100%;
			padding: 30rpx;
			box-sizing: border-box;
			.box_list_item {
				width: 100%;
				margin-bottom: 20rpx;
				&:last-child {
					margin: 0 !important;
				}
				.box_list_item_head {
					width: 100%;
					height: 100rpx;
					padding: 0 30rpx;
					box-sizing: border-box;
					background: linear-gradient(270deg, #FEFEFF 0%, #E1F7FE 100%);
					border-radius: 8rpx 8rpx 0rpx 0rpx;
					display: flex;
					align-items: center;
					justify-content: space-between;
					.loading {
						color: #279BAA;
					}
					.success {
						color: #03C68F;
					}
					.error {
						color: #E0312A;
					}
					text {
						&:nth-child(1) {
							font-size: 32rpx;
							font-weight: 500;
							color: #222222;
						}
						&:nth-child(2) {
							font-size: 26rpx;
							font-weight: 400;
						}
					}
				}
				.box_list_item_nr {
					padding: 30rpx;
					width: 100%;
					box-sizing: border-box;
					background-color: #FFFFFF;
					.box_list_item_nr_x {
						width: 100%;
						height: 1rpx;
						background-color: #E5E5E5;
					}
					.box_list_item_nr_text {
						width: 100%;
						font-size: 26rpx;
						font-weight: 400;
						color: #999999;
						margin-top: 32rpx;
					}
					.box_list_item_nr_item {
						width: 100%;
						display: flex;
						align-items: center;
						margin-bottom: 20rpx;
						text {
							&:nth-child(1) {
								font-size: 26rpx;
								font-weight: 400;
								color: #666666;
							}
							&:nth-child(2) {
								font-size: 26rpx;
								font-weight: 400;
								color: #333333;
							}
						}
					}
				}
			}
		}
	}
</style>
